module.exports = [{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":630},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Portfolio Subhendu Maji","description":"Portfolio Website of subhendu maji.","short_name":"subhendu maji","start_url":"/","background_color":"#262626","theme_color":"#40D1BA","display":"standalone","icon":"src/images/logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"138cad69ead34ab7f448a53409313513"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
